module.exports = __webpack_public_path__ + "static/media/notificacion_categoria_cumpleanios.c5cd7833.png";